import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router";
import PitchRouteGuard from "~/components/PitchRouteGuard";
import { useAuth } from "~/context/AuthContext";
import { parseTeamId, stripTeamPrefix, teamSlug } from "~/lib/team-path";
import TeamAccessDenied from "~/views/team-access-denied";

export default function TeamRouteGuard() {
  const { teamSlug: slug } = useParams();
  const { pathname, search, hash } = useLocation();
  const { user, updateUser } = useAuth();
  const teamId = parseTeamId(slug);
  const team = user?.teams?.find((item) => item.id === teamId);
  const isActiveTeam = team !== undefined && user?.team_id === team.id;

  useEffect(() => {
    if (team && !isActiveTeam) {
      updateUser({ team_id: team.id });
    }
  }, [team, isActiveTeam, updateUser]);

  if (!team) {
    return <TeamAccessDenied />;
  }

  const canonicalSlug = teamSlug(team);
  if (slug !== canonicalSlug) {
    return (
      <Navigate
        to={`/t/${canonicalSlug}${stripTeamPrefix(pathname)}${search}${hash}`}
        replace
      />
    );
  }

  if (!isActiveTeam) {
    return null;
  }

  return (
    <>
      <PitchRouteGuard />
      <Outlet />
    </>
  );
}
